import { PlacesPage } from '@features/location/components/PlacesPage';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/_shell/places')({ component: PlacesPage });
